<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model="localValue"
          :label=label
          prepend-icon="mdi-calendar"
          readonly
          v-on="on"
          :disabled="disabled"
          :error-messages="errors"
          :clearable="clearable"
          :hide-details="hideDetails"
          :rules="rules"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="localValue"
        no-title
        scrollable
        :disabled="disabled"
        @input="closeMenu"
        v-bind="this.$attrs"
        @blur="validate"
        ref="picker"
        :show-adjacent-months="false"
        :type="type"
        :range="range"

        :allowed-dates="allowedDatesFn"
    >
      <template v-if="range">
        <div class="d-flex justify-center" style="width: 100%" v-if="localValue && localValue.length === 0">
          <span>Select <strong>start</strong> {{ type }}</span>
        </div>
        <div class="d-flex justify-center" style="width: 100%" v-if="localValue && localValue.length === 1">
          <span>Select <strong>end</strong> {{ type }}</span>
        </div>
        <div class="d-flex justify-space-between" style="width: 100%" v-if="localValue && localValue.length === 2">
          <Button @click="localValue = []">Reset</Button>
          <Button @click="menu = false" primary>Done</Button>
        </div>
      </template>
    </v-date-picker>
  </v-menu>

</template>

<script>

  /**
   * Passes all attributes to the [v-datepicker](https://vuetifyjs.com/en/components/date-pickers/) component.
   */
  export default {
    name: "DatePickerFlyfood",
    props: {
      label: { type: String, default: 'Pick a date' },
      value: null,
      disabled: { type: Boolean, default: false },
      rules: { type: Array, default: () => [] },
      required: { type: Boolean, default: false },
      birthday: { type: Boolean, default: false },
      clearable: { type: Boolean, default: false },
      hideDetails: {type: Boolean, default: false },
      type: { type: String, default: 'date' },
      range: {type: Boolean, default: false },
      allowedWeekdays: { type: Array, default: () => null },
      allowedDates: { type: [Function, Array], default: null },
    },
    data: () => ({
      menu: false,
      errors: [],
    }),
    computed: {
      localValue: {
        get() {
          return this.formatDate(this.value)
        },
        set(value) {
          this.$emit('input', value)
        }
      },
    },
    watch: {
      menu (val) {
        if (this.birthday) {
          val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        }
      },
    },
    methods: {
      validate() {
        if (!this.localValue && this.required) {
          this.errors = ['Required.']
        }
      },
      closeMenu() {
        if (!this.range) {
          this.menu = false;
        }
      },
      formatDate(date) {
        if (!date) {
          return '';
        }
        // return new Date(date).toISOString().split('T')[0];
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;
        return [year, month, day].join('-');
      },
      allowedDatesFn(dateStr) {
        let allowByListOrFn = null

        if (typeof this.allowedDates === 'function') {
          allowByListOrFn = this.allowedDates
        }
        let isValid = true;
        const weekdaySet = Array.isArray(this.allowedWeekdays) && this.allowedWeekdays.length
            ? new Set(this.allowedWeekdays)
            : null

        if (!dateStr || this.type !== 'date') {
          return true;
        }

        // Apply weekday rule if provided
        if (weekdaySet) {
          const jsDate = new Date(dateStr + 'T00:00:00') // local midnight is fine for weekday
          const wd = jsDate.getDay();
          if (!weekdaySet.has(wd)) isValid = false;
        }

        // Apply custom list/predicate if provided
        if (allowByListOrFn) {
          isValid = isValid && !!allowByListOrFn(dateStr);
        }

        return isValid;
      }
    }
  }
</script>